import { render, staticRenderFns } from "./widget_twin_souls.vue?vue&type=template&id=59d2f76f&scoped=true&"
import script from "./widget_twin_souls.vue?vue&type=script&lang=js&"
export * from "./widget_twin_souls.vue?vue&type=script&lang=js&"
import style0 from "./widget_twin_souls.vue?vue&type=style&index=0&id=59d2f76f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d2f76f",
  null
  
)

export default component.exports